import * as Constants from '../constants/member-tiers';

export const getAllMemberTiers = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_ALL_MEMBER_TIERS_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/member-tiers/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_ALL_MEMBER_TIERS_SUCCESS,
          payload: res.data['member-tiers'],
        });
        resolve(res.data['member-tiers']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_ALL_MEMBER_TIERS_FAILED, payload: error });
        reject(error);
      });
  });

export const getMemberTier = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_MEMBER_TIER_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/member-tiers/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_MEMBER_TIER_SUCCESS, payload: res.data.tier });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_MEMBER_TIER_FAILED, payload: error });
        reject(error);
      });
  });
